import { GET_AC_FIELDS } from '../types/index';

export default (fields = [], action) => {
  switch (action.type) {
    case GET_AC_FIELDS:
      return action.payload;
    default:
      return fields;
  }
}